module.exports = __webpack_public_path__ + "static/media/tai-lai-trinh-duyet.88bfb3ad.mp3";